import * as styles from "../style.module.css";
import ReviewSummary from "./reviewSummary";
import AdditionalConfirmationEmails from "./additionalConfirmationEmails";
import AdditionalUploads from "./additionalUploads";
import React from "react";

export function SectionContent({cache, setCache, cartData}) {
    return(
        <div className={styles.sectionContent}>
            <ReviewSummary cartData={cartData} />
            <AdditionalConfirmationEmails cache={cache} setCache={setCache} />
            <AdditionalUploads cache={cache} setCache={setCache} />
        </div>
    );
}
